<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      width="780px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editFrom.cancel()"
    >
      <EditFrom
        ref="editFrom"
        :orderCode="orderCode"
        @close="close"
        @confirm="confirm()"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editFrom.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_upload') || '上传' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditFrom from './index.vue'
export default {
  components: { EditFrom },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    orderCode: { type: String, default: '' },
  },
  methods: {
    confirm() {
      this.$refs.editFrom.choiceData().then((res) => {
        if (!res) return
        this.$emit('confirm', res)
        this.close()
      })
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
